import { render, staticRenderFns } from "./RevisionHistoryItem.vue?vue&type=template&id=7ccc0531&functional=true&"
import script from "./RevisionHistoryItem.vue?vue&type=script&lang=js&"
export * from "./RevisionHistoryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports